import styled from 'styled-components';

export const StyledFlex = styled.div`
  article {
    width: 100%;
  }
`;
